import * as Yup from "yup";

import {NotificationEvent} from "@/lib/types/maintenance.ts";
import {NotificationFormRow} from "@/pages/maintenance/maintenance-create/tabs/notifications/MaintenanceScheduleNotificationsTab.types.ts";
import {TimingUnit} from "@/pages/maintenance/maintenance-create/tabs/notifications/NotificationRow.types.ts";
import {timingToOffset} from "@/pages/maintenance/maintenance-create/tabs/notifications/NotificationRow.utils.ts";

export const MaintenanceScheduleNotificationsSchema = Yup.object({
  notifications: Yup.array()
    .of(
      Yup.object({
        id: Yup.number().optional(),
        offset: Yup.number().required(),
        timing_amount: Yup.number()
          .transform((value, originalValue) =>
            originalValue === "" || originalValue === null || Number.isNaN(value) ? null : value
          )
          .nullable()
          .min(0, "Must be 0 or greater.")
          .defined(),
        timing_unit: Yup.string().oneOf(Object.values(TimingUnit)).required(),
        event: Yup.string().required(),
        contact_group_ids: Yup.array().of(Yup.number().required()).required(),
      })
    )
    .required()
    .test("unique-notifications", "", function (values) {
      if (!values) return true;
      const errors: Yup.ValidationError[] = [];
      const offsets = values.map((item) => {
        if (!item || item.timing_amount == null || !item.timing_unit) return null;
        return timingToOffset(item.timing_amount, item.timing_unit as TimingUnit);
      });
      values.forEach((item, index) => {
        if (!item) return;
        const offset = offsets[index];
        if (offset == null) return;
        const isDuplicate = values.some(
          (other, otherIndex) => otherIndex !== index && offsets[otherIndex] === offset && other?.event === item.event
        );
        if (isDuplicate) {
          errors.push(
            this.createError({
              path: `${this.path}[${index}].timing_amount`,
              message: "A reminder already exists for this timestamp.",
            })
          );
        }
      });
      if (errors.length > 0) {
        return new Yup.ValidationError(errors);
      }
      return true;
    }),
});

export const DEFAULT_NOTIFICATION_ROW: NotificationFormRow = {
  offset: 0,
  timing_amount: null,
  timing_unit: TimingUnit.MINUTES_BEFORE,
  event: NotificationEvent.START,
  contact_group_ids: [],
};

export const MaintenanceScheduleNotificationsDefaultValues = {
  notifications: [DEFAULT_NOTIFICATION_ROW],
};
